import React from 'react'
import { useHistory } from "react-router-dom";

export default function SingleEventCard(props) {
    let history = useHistory();

    let onEventPress = () => {
        console.log(history.location)
        props.history.push({ 
            pathname: 'dashboard/event',
            state: {
                id: props.info._id
            }
           });
    }
    return (
        <div className="max-w-7x1 px-4 py-1 mt-1 mb-2 mx-auto shadow-lg bg-white" onClick={onEventPress}>
            <div className="w-full mt-5 rounded-1xl px-5 py-2">
                 {props.info.name}
            </div>
            <div className="w-full rounded-1xl px-5">
                 {props.info.description}
            </div>
        </div>
    )
}
